;(function () {
  'use strict'
  angular.module('contrast.tsv').controller('TsvTempCodeCtrl', TsvTempCodeCtrl)

  function TsvTempCodeCtrl(
    $scope,
    $location,
    $translate,
    logger,
    AuthService,
    logoutService,
    ProfileService,
    tsvApiConfig,
    TSV_TYPES
  ) {
    'ngInject'

    var _tsvType

    angular.extend($scope, {
      model: {}
    })

    angular.extend($scope, {
      submit: submit,
      logout: logout
    })

    function init() {
      _tsvType = ProfileService.getTsvType()
    }

    function submit() {
      if (_tsvType == TSV_TYPES.GOOGLE) {
        tsvApiConfig.sendTemporalCode({ email: $scope.model.email }).then(
          function () {
            logger.logSuccess(
              $translate.instant('variable_tsvSignIn_canTSignIn', {
                email: $scope.model.email
              })
            )
            AuthService.setInitializeTsv(false)
            $location.path('tsv/verification', true)
          },
          function (response) {
            $scope.model.error = response.data.messages[0]
          }
        )
      } else {
        tsvApiConfig.sendEmailToAdmins({ email: $scope.model.email }).then(
          function () {
            logger.logSuccess(
              ' ' +
                $translate.instant('detail_tsvSignIn_emailNotificationMethod')
            )
            AuthService.setInitializeTsv(false)
            $location.path('tsv/backup-code', true)
          },
          function (response) {
            $scope.model.error = response.data.messages[0]
          }
        )
      }
    }

    function logout() {
      logoutService.logout({ redirectToSignin: true })
    }

    init()
  }
})()
